<template>
  <div>
    <PageHead title="组织机构"></PageHead>
    <div class="oa-layout-content">
      <div class="mb20">
        <a-button type="primary" @click="add" icon="plus"> 新建</a-button>
      </div>
      <a-table
        v-if="!loading"
        :pagination="false"
        :columns="columns"
        :data-source="data"
        childrenColumnName="treeList"
        rowKey="id"
        defaultExpandAllRows
        :loading="loading"
      >
        <span slot="dirLevel" slot-scope="text">{{
          getCatalogue(text, catalogueList)
        }}</span>
        <span slot="flag" slot-scope="text">
          {{ text == 1 ? '部门' : '公司' }}
        </span>
        <div slot="status" class="statusDiv" slot-scope="text, record">
          <a-switch
            :default-checked="text == 1"
            @change="onChange(record)"
            :loading="switchloading == record.id"
          />
        </div>
        <div slot="action" slot-scope="text, record">
          <a-button
            type="link"
            class="btn-link"
            @click="goDetial(record.id, 1)"
          >
            查看
          </a-button>
          <a-divider type="vertical" />
          <a-button
            type="link"
            class="btn-link"
            @click="goDetial(record.id, 2)"
          >
            编辑
          </a-button>
        </div>
      </a-table>
    </div>
    <appfloor></appfloor>
  </div>
</template>
<script>
const columns = [
  {
    title: '组织机构名称',
    dataIndex: 'organizationName',
    key: 'organizationName',
    ellipsis: true
  },
  {
    title: '部门id',
    dataIndex: 'id',
    key: 'id',
    ellipsis: true,
    align: 'center'
    // width: 100,
  },
  {
    title: '自定义部门id',
    dataIndex: 'organizationNumber',
    key: 'organizationNumber',
    ellipsis: true
  },
  {
    title: '目录级别',
    dataIndex: 'dirLevel',
    key: 'dirLevel',
    scopedSlots: { customRender: 'dirLevel' },
    ellipsis: true,
    align: 'center'
    // width: 100,
  },
  {
    title: '机构类型',
    dataIndex: 'flag',
    scopedSlots: { customRender: 'flag' },
    key: 'flag',
    ellipsis: true,
    align: 'center'
    // width: 100,
  },
  {
    title: '机构系统管理员',
    dataIndex: 'systemAdminIds',
    key: 'systemAdminIds',
    ellipsis: true
  },
  {
    title: '启用',
    dataIndex: 'enableNum',
    scopedSlots: { customRender: 'status' },
    key: 'enableNum',
    // ellipsis: true,
    align: 'center'
    // width: 80,
  },
  {
    title: '更新时间',
    dataIndex: 'modifyTime',
    key: 'modifyTime',
    ellipsis: true
    // width: 150,
  },
  {
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'left',
    width: 120
  }
]

import { getTreeList, updateOrganizationEnableNum } from './api/api'
export default {
  data() {
    return {
      expand: false,
      expandedKeys: [10010], //当前默认选中的机构 ，为了保证默认展开
      data: [],
      columns,
      switchloading: '',
      loading: true,
      catalogueList: [
        {
          label: '顶级',
          value: '1'
        },
        {
          label: '二级',
          value: '2'
        },
        {
          label: '三级',
          value: '3'
        },
        {
          label: '四级',
          value: '4'
        },
        {
          label: '五级',
          value: '5'
        }
      ]
    }
  },
  created() {
    this.load()
  },
  methods: {
    //获取目录级别
    getCatalogue(value, list) {
      let Catalogue = list.find((item) => {
        return item.value == value
      })
      if (Catalogue) {
        return Catalogue.label
      } else {
        return value
      }
    },
    load() {
      getTreeList().then((res) => {
        this.data = res.data.data
        this.loading = false
      })
    },
    //
    onChange(checked) {
      //启用禁用
      this.switchloading = checked.id
      let data = {
        id: checked.id
      }
      if (checked.enableNum == 1) {
        data.enableNum = 2
      } else {
        data.enableNum = 1
      }
      updateOrganizationEnableNum(data).then((res) => {
        this.switchloading = ''
        this.load()
      })
    },
    showDeleteConfirm() {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk() {},
        onCancel() {}
      })
    },
    add() {
      this.$router.push('/addInstitutionalFramework')
    },
    goDetial(id, isCreate) {
      this.$router.push({
        path: '/addInstitutionalFramework',
        query: {
          id,
          isCreate
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.statusDiv {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/system/InstitutionalFramework.vue